<script lang="ts">
	import Icon from "./Icon.svelte";

	export let name: string;
	export let icon: string;
	export let value: number | string = "";
	export let index: number | null = null;
</script>

<div
	class="border-secondary-200 flex items-center gap-[.125rem] whitespace-nowrap rounded-full border px-[.62rem] py-1"
>
	<Icon {icon} class="h-4" />
	{#if index !== null}
		<span class="text-2xs font-semibold">{index + 1}.</span>
	{/if}
	<span class="text-2xs">{name}</span>
	{#if value}
		<span class="text-2xs whitespace-nowrap font-semibold">: {value}</span>
	{/if}
</div>
